import dateFnsDE from 'date-fns/locale/de';
import dateFnsFR from 'date-fns/locale/fr';
import dateFnsEN from 'date-fns/locale/en-GB';
import dateFnsCN from 'date-fns/locale/zh-CN';

/**
 * returns a locale in a standard format with language and country
 */
export function getISOLocale(locale) {
    switch (locale) {
    case 'de':
        return 'de_CH';
    case 'fr':
        return 'fr_CH';
    case 'en':
        return 'en_GB';
    case 'cn':
        return 'zh_CN';
    default:
        return locale;
    }
}

export function getDateFnsLocale(locale) {
    switch (locale) {
    case 'de':
        return dateFnsDE;
    case 'fr':
        return dateFnsFR;
    case 'en':
        return dateFnsEN;
    case 'cn':
        return dateFnsCN;
    default:
        return dateFnsDE;
    }
}
